import { useEffect, useRef, useState } from 'react';
import { fetchPumpAccountingWacProgress } from '../adminApi';

/**
 * Polls server-side WAC apply progress while a long-running correction is in flight.
 */
export function useWacApplyProgressPoll(pumpId, active) {
  const [progress, setProgress] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!active || !pumpId) {
      setProgress(null);
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
      return undefined;
    }

    const poll = () => {
      fetchPumpAccountingWacProgress(pumpId)
        .then((res) => {
          if (res?.progress) {
            setProgress(res.progress);
          }
        })
        .catch(() => {});
    };

    poll();
    timerRef.current = setInterval(poll, 1500);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [active, pumpId]);

  return progress;
}

export function isWacFixType(fixType) {
  return typeof fixType === 'string' && fixType.startsWith('wac_recalc_apply');
}
